import { type StateCreator } from "zustand";

import type { Airport, AirportState } from "./types";

const initState = {
  selectedAirport: { value: "", label: "" },
};

export const createAirportState: StateCreator<
  AirportState,
  [["zustand/devtools", never]]
> = (set, get) => ({
  ...initState,

  airportActions: {
    setSelectedAirport: (airport: Airport) => {
      set({ selectedAirport: airport });
    },
    resetState: () => set(initState),
  },

  airportUtils: {
    generateSummaryText: () => get().selectedAirport.label,
  },
});
